// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "351cd1bf87b028debaaa06aa37ec5810f9665d30/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};